import { UserDevice } from './user-device.model';
import { User } from './user.model';

/**
 * Enumeration for various types of registration states.
 * Represents the nature of a registration event or process.
 */
export enum RegistrationType {
    NoRegistration = 0,
    Initial = 1,
    TokenRefresh = 2,
    UserChange = 3,
}

/**
 * Represents the history of a device registration.
 */
export interface DeviceRegistrationHistory {
    id?: string;
    userDeviceId: string;
    userId: string;
    deviceId: string;
    deviceToken: string;
    platform: string;
    deviceModel?: string;
    deviceModelDisplay?: string;
    registrationType: RegistrationType;
    registeredAt: string;
    createdOn: string;
    userDevice?: UserDevice;
    user?: User;
    tenantId?: string;
    branchId?: string;
}
